import chart from '../HorizontalLineChart/chart';
import PDFMakeChartConverter from './PDFMakeChartConverter';

export default async (node, options) => {
  const chartConvertor = new PDFMakeChartConverter(chart);

  options.chartOptions = {
    primaryColour: node.meta.primaryBarColour,
    highlightColour: node.meta.highlightBarColour,
    axisLabels: node.meta.axisLabels,
    animate: false,
  };

  return chartConvertor.convert(node, options);
};
